import { NgClass } from '@angular/common';
import { Component, computed, input, output, viewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICtaForm } from '@campaign-form/campaign-form.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { ALL_CREATORS_ID } from '@shared/constants/all-creators.constants';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CtaSummaryPanelComponent } from '../cta-summary-panel/cta-summary-panel.component';

@Component({
  imports: [
    CtaSummaryPanelComponent,
    IconBadgeComponent,
    IconComponent,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    NgClass,
  ],
  selector: 'app-global-deliverables-list',
  templateUrl: './global-deliverables-list.component.html',
})
export class GlobalDeliverablesListComponent {
  public readonly getExistingDeliverablesCount = input.required<(ctaId: string, creatorId: string) => number>();
  public readonly getExistingExecutionsCount = input.required<(ctaId: string, creatorId: string) => number | null>();
  public readonly getExistingKpisCount = input.required<(ctaId: string, creatorId: string) => number>();
  public readonly globalAndSharedCtaValues = input.required<FormGroup<ICtaForm>['value'][]>();

  public readonly hideShareStatusIcon = input<boolean>(false);
  public readonly loading = input<boolean>(false);
  public readonly isTemplateSettings = input<boolean>(false);
  public readonly hasGlobalBriefingNote = input<boolean>(false);

  public readonly addDeliverablesForCta = output<string>();
  public readonly addExecutionsForCta = output<string>();
  public readonly addKpisForCta = output<string>();
  public readonly addGlobalDeliverables = output<void>();
  public readonly addGlobalBriefingNotes = output<void>();
  public readonly editCta = output<string>();
  public readonly editCtaGroup = output<string>();
  public readonly removeCtaGlobally = output<string>();
  public readonly copyCta = output<string>();

  public readonly ALL_CREATORS_ID = ALL_CREATORS_ID;

  public readonly allExpanded = computed(() => {
    const panels = this.ctaPanels();

    return panels.length > 0 && panels.every((p) => p.isExpanded());
  });
  public readonly globalCtaCount = computed(
    () => this.globalAndSharedCtaValues().filter((cta) => cta.isAllCreators).length,
  );
  public readonly sharedCtaCount = computed(
    () => this.globalAndSharedCtaValues().filter((cta) => !cta.isAllCreators).length,
  );

  private readonly ctaPanels = viewChildren(CtaSummaryPanelComponent);

  public expandCollapseAll(): void {
    const shouldExpand = !this.allExpanded();

    this.ctaPanels().forEach((p) => (shouldExpand ? p.expansionPanel().open() : p.expansionPanel().close()));
  }
}
